import React from 'react'
import emailjs from 'emailjs-com';
import '../styles/Contact.css';

const Contact = () => {
    const handleSubmit = (e) => {
        e.preventDefault();
    
        emailjs.sendForm(
            "service_91ed37i",
            "template_uhh7k0b",
            e.target,
            "0ulvLsncFYV9WXXZe"
        )
        .then((result) => {
            console.log("Email sent successfully:", result.text);
            e.target.reset();
        })
        .catch((error) => {
            console.error("Error sending email:", error.text);
        });
    };
    return (
        <div className="contact">
            <h1>Contact Me</h1>
            <form className="cCard" onSubmit={handleSubmit}>
                <div className="pInfo">
                    <input type="text" id="name" name="name" placeholder="your name" />
                    <input type="tel" id="number" name="number" placeholder="your phone number" />
                </div>
                <div className="pEmail">
                    <input type="email" id="email" name="email" placeholder="your email" />
                </div>
                <div className="subject">
                    <textarea id="subject" name="subject" placeholder="your message"></textarea>
                </div>
                <button type="submit">send message</button>
            </form>
            <hr />
            <div className="social">
                <div className="mail">
                    <a href="mailto:your-email@example.com">okonkwo@uni.minerva.edu</a>
                </div>
                <div className="linhub">
                    <a href="https://www.linkedin.com/in/jonathan-okonkwo/"><i className="fa-brands fa-linkedin"></i></a>
                    <a href="https://github.com/1-JaeYo"><i className="fa-brands fa-github github2"></i></a>
                    <a href="https://www.minerva.edu/"><img src="./images/uniLogo.png" alt="" id='uniLogo' /></a>
                </div>
            </div>
        </div>
    )
}

export default Contact;
